import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def7ec994c039d/src/layout/home/homeContent.tsx");
